(function() {
  function init() {
    var items = document.querySelectorAll('.noxor-faq__item');
    if (!items.length) return;

    /* Scroll reveal */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var idx = Array.from(items).indexOf(entry.target);
        setTimeout(function() {
          entry.target.classList.remove('noxor-faq__item--hidden');
          entry.target.classList.add('noxor-faq__item--visible');
        }, idx * 100);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    items.forEach(function(item) {
      observer.observe(item);

      /* Accordion toggle */
      var btn = item.querySelector('.noxor-faq__question');
      btn.addEventListener('click', function() {
        var isOpen = item.classList.contains('noxor-faq__item--open');
        items.forEach(function(i) { i.classList.remove('noxor-faq__item--open'); });
        if (!isOpen) item.classList.add('noxor-faq__item--open');
      });

      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
